import { forwardRef } from 'react';

const ClickableDiv = forwardRef<HTMLDivElement, any>((props, ref) => (
  <div role="button" tabIndex={0} ref={ref} {...props} />
));

ClickableDiv.displayName = 'ClickableDiv';

export default ClickableDiv;
